import { createSlice } from '@reduxjs/toolkit';

import type * as CollectionPageTypes from './types';

const name = 'collectionPage';

const initialState: CollectionPageTypes.CollectionPageState = {
    showActivitySidebar: true,
    showFiltersSidebar: false,
    showDetailsPanel: false,
};

export const collectionPageSlice = createSlice({
    name,
    initialState,
    reducers: {
        resetCollectionPageStore() {
            return initialState;
        },
        setShowActivitySidebar(state, { payload }: CollectionPageTypes.CollectionActivityActionTypes) {
            return { ...state, showActivitySidebar: payload, showFiltersSidebar: false };
        },
        setShowFiltersSidebar(state, { payload }: CollectionPageTypes.CollectionActivityActionTypes) {
            return { ...state, showFiltersSidebar: payload, showActivitySidebar: false };
        },
        setShowDetailsPanel(state, { payload }: CollectionPageTypes.CollectionActivityActionTypes) {
            return { ...state, showDetailsPanel: payload };
        },
    },
});
